import * as React from 'react';
import { IVehicle, IVehicleId } from 'data/schema';

interface IEndComparisonDialogProps {
  vehicleIds: Array<IVehicleId | undefined>;
  vehicles: Record<IVehicleId, IVehicle>;
  onVehicleSelected: (vehicleId: IVehicleId | undefined) => void;
}

/**
 * Dialog content for selecting which vehicle to keep active after ending comparison.
 * Displays radio buttons for each vehicle in the comparison.
 */
export default function EndComparisonDialog({ vehicleIds, vehicles, onVehicleSelected }: IEndComparisonDialogProps) {
  return (
    <fieldset className="space-y-3">
      <legend className="sr-only">Select vehicle to continue with</legend>
      {vehicleIds.filter(Boolean).map((vehicleId, index) => {
        const vehicle = vehicles[vehicleId!];
        const displayName =
          vehicle?.carDisplayName || vehicle?.vinOrMarketingCode || vehicle?.prString || `Vehicle ${index + 1}`;

        return (
          <div key={vehicleId} className="flex items-center">
            <input
              type="radio"
              id={`vehicle-${vehicleId}`}
              name="selectedVehicle"
              value={vehicleId}
              className="size-4 border-gray-300 text-teal focus:ring-teal"
              defaultChecked={index === 0}
              onChange={(e) => {
                if (e.target.checked) {
                  onVehicleSelected(vehicleId);
                }
              }}
              data-testid={`vehicle-radio-${index}`}
            />
            <label htmlFor={`vehicle-${vehicleId}`} className="ml-3 block text-sm font-medium text-gray-700">
              {displayName}
            </label>
          </div>
        );
      })}
    </fieldset>
  );
}
